import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  DOCUMENTS_FEATURE_KEY,
  DocumentsState,
  documentEntityAdapter
} from './documents.reducer';

// Lookup the 'Documents' feature state managed by NgRx
const getDocumentsState = createFeatureSelector<DocumentsState>(
  DOCUMENTS_FEATURE_KEY
);

export const {
  selectIds: getDocumentIds,
  selectEntities: getDocumentEntities,
  selectAll: getAllDocuments,
  selectTotal: getTotalDocuments
} = documentEntityAdapter.getSelectors(getDocumentsState);

const getLoaded = createSelector(
  getDocumentsState,
  (state: DocumentsState) => state.loaded
);

const getLoading = createSelector(
  getDocumentsState,
  (state: DocumentsState) => state.loading
);

const getError = createSelector(
  getDocumentsState,
  (state: DocumentsState) => state.error
);

const getSelectedId = createSelector(
  getDocumentsState,
  (state: DocumentsState) => state.selectedId
);

const getSelectedDocument = createSelector(
  getDocumentEntities,
  getSelectedId,
  (documents, id) => {
    const result = documents[id];
    return result ? Object.assign({}, result) : undefined;
  }
);

export const documentsQuery = {
  getLoaded,
  getError,
  getAllDocuments,
  getSelectedDocument
};
